import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { Cliente } from "../../../services/Cliente";
import { toast } from "react-toastify";
import { IClienteDTO } from "../../../types/cliente";
import { Agendamento } from "../../../services/Agendamento";

export const useDispatcherCustomerDetail = () => {
  const navigate = useNavigate();
  const [searcParam] = useSearchParams();
  const idCliente = searcParam.get("id");
  const { uuidAgendamento } = useParams();
  const { setIsLoad } = useContextSite();
  const [dataClient, setDataClient] = useState({} as IClienteDTO);

  const getCliente = useCallback(() => {
    setIsLoad(true);
    Cliente.byId({ uuidCliente: idCliente })
      .then(({ data }) => {
        setDataClient(data);
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => toast.error(message)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }, []);

  useEffect(() => {
    if (idCliente) {
      getCliente();
    }
  }, [idCliente]);

  function handleConfirm() {
    setIsLoad(true);
    Agendamento.vincularAgendamentoAoCliente({
      uuid: uuidAgendamento,
      uuidCliente: idCliente,
    })
      .then(({ data }) => {
        navigate(`/agendamento/${data?.uuid}/servicos`);
        return;
      })
      .catch((error) => toast.error(error.message))
      .finally(() => setIsLoad(false));
  }

  return { navigate, dataClient, handleConfirm };
};
